module.exports = __webpack_public_path__ + "img/d7e0cf7d6685397a6f41c69740b8c7c5.svg";